import { apm } from "@elastic/apm-rum";
import { Brightness4, Brightness5 } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";

export default function DarkMode() {
  const { t } = useTranslation();

  const darkTheme = defaultStore((state) => state.darkTheme);
  const changeDarkTheme = defaultStore((state) => state.changeDarkTheme);

  //change darkmode and save on localstorage
  const handleChangeDarkTheme = () => {
    changeDarkTheme(!darkTheme);
    if (darkTheme) {
      localStorage.setItem("theme", "light");
    } else {
      localStorage.setItem("theme", "dark");
    }
  };

  return (
    <Tooltip
      title={darkTheme ? t("tooltip.lighttheme") : t("tooltip.darktheme")}
      placement="bottom"
      enterDelay={400}
      classes={{ tooltip: "infra3d-buttonDescription" }}
    >
      <IconButton
        size="medium"
        aria-haspopup="true"
        onClick={() =>
          monitor(apm, "change-status | DarkTheme", handleChangeDarkTheme)
        }
        classes={{ root: "infra3d-iconBackground" }}
        color="primary"
        sx={{
          color: "white",
          "@media (hover: hover)": {
            ":hover": { color: "secondary.main" },
          },
        }}
      >
        {darkTheme && <Brightness5 fontSize="medium" />}
        {!darkTheme && <Brightness4 fontSize="medium" />}
      </IconButton>
    </Tooltip>
  );
}
